import { Text, Card, Flex, Heading, IconButton, Button, useToast } from '@chakra-ui/react';
import { useResource, useResourcesInfinite } from 'datx-jsonapi-react';
import { FC } from 'react';

import CloseIcon from '@/assets/icons/ic-close.svg';

import { ChatProfile } from '@/components/ui/shared/chat/ChatPopup/components/types';
import { IToastType } from '@/enums/ToastType';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { useStores } from '@/hooks/useStores';
import { queryAllChatMessages } from '@/queries/chat-messages';
import { queryChatChannelOfUser } from '@/queries/event-chat-channels';
import { EventChatChannel } from '@/resources/EventChatChannel';

interface IDeleteChat {
  onClose: () => void;
  onDelete: () => void;
  chat_channel_id: string;
  profile: ChatProfile | null;
}

export const DeleteChat: FC<IDeleteChat> = ({ onClose, chat_channel_id, onDelete, profile }) => {
  const { store } = useStores();
  const toast = useToast();
  const { eventId } = useQueryParams<{ eventId: string }>({
    eventId: StringParam,
  });
  const { mutate } = useResourcesInfinite(queryAllChatMessages(chat_channel_id));

  const { mutate: mutateChannel } = useResource(queryChatChannelOfUser(profile?.user?.id, eventId));

  async function deleteChat() {
    try {
      await store.request(`${EventChatChannel.type}/${chat_channel_id}`, 'DELETE');

      await mutate();
      await mutateChannel(undefined, { revalidate: false });

      onDelete();
    } catch (e) {
      toast({ status: IToastType.ERROR, title: 'Error' });
    }
  }

  return (
    <Flex
      backgroundColor="rgba(0, 0, 0, 0.8)"
      zIndex="10"
      position="absolute"
      top={0}
      bottom={0}
      left={0}
      right={0}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Card w="290px" p={6}>
        <Flex flexDirection="column">
          <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
            <Heading fontSize="xl">Delete chat</Heading>
            <IconButton
              size="xs"
              onClick={() => onClose()}
              aria-label="Close"
              ml="2"
              variant="unstyled"
              icon={<CloseIcon width="24px" />}
            />
          </Flex>
          <Text my={4}>This action can’t be undone.</Text>
          <Flex>
            <Button onClick={() => deleteChat()} size="sm" colorScheme="black">
              Delete chat
            </Button>
            <Button onClick={() => onClose()} size="sm" variant="black">
              Cancel
            </Button>
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};
